import Cases from "./Pages/Cases";
import Users from "./Pages/Users";
import Projects from "./Pages/Projects";
import Terms from "./Pages/Terms";
import Commissions from "./Pages/Commissions";
import NewCase from "./Pages/NewCase";
import Agency from "./Pages/Agency";
import ChangePassword from "./Pages/ChangePassword";

import {
  FiInbox,
  FiUserCheck,
  FiHome,
  FiActivity,
  FiAnchor,
  FiAward,
  FiPlus,
  FiSettings,
  FiLock,
} from "react-icons/fi";

export default [
  {
    path: "/",
    name: "Home",
    Icon: FiHome,
    component: Cases,
    hidden: true,
  },
  {
    path: "/cases",
    name: "Cases",
    Icon: FiInbox,
    component: Cases,
  },
  {
    path: "/new-case",
    name: "New Case",
    Icon: FiPlus,
    component: NewCase,
  },
  {
    path: "/projects",
    name: "Projects",
    Icon: FiActivity,
    component: Projects,
  },
  {
    path: "/agency",
    name: "Agency",
    Icon: FiSettings,
    component: Agency,
  },
  {
    path: "/users",
    name: "Users",
    hidden: false,
    Icon: FiUserCheck,
    component: Users,
  },
  {
    path: "/change-password",
    name: "Change Password",
    Icon: FiLock,
    component: ChangePassword,
  },
  {
    path: "/terms",
    name: "Terms",
    Icon: FiAnchor,
    component: Terms,
  },
  {
    path: "/commissions",
    name: "Commissions",
    Icon: FiAward,
    component: Commissions,
  },
];
